export const getSubcriptionTypeCount = ({
  isCentreAvailable,
  isIconicAvailable,
  isPlusAvailable,
  isLiteAvailable
}) => {
  let count = 1;
  if (isIconicAvailable) {
    count += 1;
  }
  if (isPlusAvailable) {
    count += 1;
  }
  if (isLiteAvailable) {
    count += 1;
  }
  if (isCentreAvailable) {
    count += 1;
  }
  return count;
};

export const subscriptionFeaturesAvailable = (subscriptions) => {
  const featureName = [];
  const free = [];
  const offline = [];
  const iconic = [];
  const plus = [];
  const lite = [];

  subscriptions.forEach(
    ({ name, isIconic, isPlus, isLite, isFree, isOffline }) => {
      featureName.push(name);
      free.push(isFree);
      offline.push(isOffline);
      iconic.push(isIconic);
      plus.push(isPlus);
      lite.push(isLite);
    }
  );

  return {
    featureName,
    free,
    offline,
    iconic,
    plus,
    lite
  };
};

export const CHOOSE_CENTRE_ROUTE_MAPPING = {
  TMUVD:
    '/goal/kota-jee-coaching/TMUVD/centre/Kota-Centre/NXG6I0UBPB?redirection_enabled=true&source=subscriptionWeb',
  YOTUH:
    '/goal/kota-neet-coaching/YOTUH/centre/Kota-Centre/NXG6I0UBPB?redirection_enabled=true&source=subscriptionWeb',
  TPSBK:
    '/goal/kota-foundation-coaching/TPSBK/centre/Kota-Centre/NXG6I0UBPB?redirection_enabled=true&source=subscriptionWeb',
  KSCGY:
    '/goal/UPSC-coaching/KSCGY/centre/Delhi-Centre/ZKSQFCU30C?redirection_enabled=true&source=subscriptionWeb',
  XNDUS:
    '/goal/CAT-Other-MBA-Entrance-Tests-foundation-coaching/XNDUS/centre/Delhi-Centre/1DJT99ZYF7?redirection_enabled=true&source=subscriptionWeb',
  BBKWG:
    '/goal/CA-Foundation-coaching/BBKWG/centre/Delhi-Centre/C1XCCJBEVM?redirection_enabled=true&source=subscriptionWeb',
  BDNTN:
    '/goal/ssc-je-state-ae-exams/BDNTN/centre/jaipur-centre/9FRN2WN030?redirection_enabled=true&source=subscriptionWeb',
  JAQRK:
    '/goal/gate-ese-ee-ec-coaching/JAQRK/centre/Delhi-Centre/CSGYMDHPKG?redirection_enabled=true&source=subscriptionWeb',

  PZSIU:
    '/goal/gate-ese-ce-coaching/PZSIU/centre/Delhi-Centre/CSGYMDHPKG?redirection_enabled=true&source=subscriptionWeb',

  NVLIA:
    '/goal/gate-ese-cs-it-coaching/NVLIA/centre/Delhi-Centre/CSGYMDHPKG?redirection_enabled=true&source=subscriptionWeb',

  QGFRK:
    '/goal/gate-ese-me-coaching/QGFRK/centre/Delhi-Centre/CSGYMDHPKG?redirection_enabled=true&source=subscriptionWeb',

  KNMDN:
    '/goal/mht-cet-coaching/KNMDN/centre/kolhapur-centre/KEDWFMXDLL?redirection_enabled=true&source=subscriptionWeb'
};
